/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Variant gallery image filtering.
  // Desktop (stacked) layout: hide the non-matching slides.
  // Mobile (Flickity slider): hide the non-matching cells + re-flow the slider,
  // then hand the actual cell-selection back to the theme's native updateMedia so
  // the selected image lazy-loads correctly (selecting the cell ourselves leaves
  // the main image blank, because the theme only loads a cell's image on select).
  (function () {
    var DESKTOP_MIN = 1024; // matches the sticky tall-layout breakpoint in custom.css

    function getColorData(productInfo) {
      var mapEl = productInfo.querySelector('[id^="MediaColorData-"]');
      if (!mapEl) return null;
      try { return JSON.parse(mapEl.textContent); } catch (e) { return null; }
    }

    function mediaIdOf(el) {
      // data-media-id looks like "template--123__main-456-789"; the real media id is the last segment
      return String(el.getAttribute('data-media-id')).split('-').pop();
    }

    function getVariantColor(variant, colorIndex) {
      return [variant.option1, variant.option2, variant.option3][colorIndex] || variant.option1;
    }

    function hasColorData(data) {
      return data && data.mediaColors &&
        Object.values(data.mediaColors).some(function (c) { return c && c.length > 0; });
    }

    // The colour of the currently selected variant, or null.
    function currentSelectedColor(productInfo) {
      var selectedEl = productInfo.querySelector('variant-selects [data-selected-variant]');
      var data = getColorData(productInfo);
      if (!selectedEl || !data) return null;
      try {
        var variant = JSON.parse(selectedEl.innerHTML);
        return variant ? getVariantColor(variant, data.colorIndex || 0) : null;
      } catch (e) { return null; }
    }

    // The active Flickity gallery instance (mobile), or null on desktop / before init.
    function getActiveFlickity(productInfo) {
      if (!(window.theme && window.theme.Flickity)) return null;
      var sliderEl = productInfo.querySelector('[data-product-single-media-slider]');
      if (!sliderEl) return null;
      var flkty = window.theme.Flickity.data(sliderEl);
      return (flkty && flkty.isActive) ? flkty : null;
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: ' + (DESKTOP_MIN - 1) + 'px)').matches;
    }

    function showAll(productInfo) {
      productInfo.querySelectorAll(
        '[data-product-single-media-wrapper], [data-product-single-media-thumbs] [data-media-id]'
      ).forEach(function (el) { el.style.display = ''; });
    }

    // Show only the matching colour's slides + thumbnails. Images with no colour
    // assigned (shared shots) are always shown. Returns true if it ran.
    function applyVisibility(productInfo, color) {
      var data = getColorData(productInfo);
      if (!hasColorData(data)) return false;
      productInfo.querySelectorAll(
        '[data-product-single-media-wrapper], [data-product-single-media-thumbs] [data-media-id]'
      ).forEach(function (el) {
        var mediaColor = data.mediaColors[mediaIdOf(el)];
        el.style.display = (!mediaColor || mediaColor === color) ? '' : 'none';
      });
      return true;
    }

    // Tell Flickity (gallery + thumbnail nav) that the visible cell set changed.
    function reflowFlickity(productInfo, flkty) {
      try { flkty.reloadCells(); flkty.resize(); } catch (e) {}
      try {
        var thumbEl = productInfo.querySelector('[data-product-single-media-thumbs]');
        var tf = thumbEl && window.theme.Flickity.data(thumbEl);
        if (tf && tf.isActive) { tf.reloadCells(); tf.resize(); }
      } catch (e) {}
    }

    function setupProductInfo(productInfo) {
      if (productInfo.getAttribute('data-tall-layout') !== 'true') return;
      if (productInfo._variantFilterSetup) return;
      productInfo._variantFilterSetup = true;

      var originalUpdateMedia = productInfo.updateMedia.bind(productInfo);

      productInfo.updateMedia = function (media) {
        var data = getColorData(this);
        var mediaColor = (media && data) ? data.mediaColors[String(media.id)] : null;
        var flkty = getActiveFlickity(this);

        if (mediaColor && hasColorData(data)) {
          if (flkty) {
            // Mobile: hide other colours, re-flow, then let the THEME select +
            // lazy-load the cell (this is what keeps the main image from blanking).
            applyVisibility(this, mediaColor);
            reflowFlickity(this, flkty);
            originalUpdateMedia(media);
            return;
          }
          if (!isMobileViewport()) {
            // Desktop stacked: just hide the non-matching slides.
            applyVisibility(this, mediaColor);
            return;
          }
        }

        // No colour data, or slider not ready: native behaviour, nothing hidden.
        showAll(this);
        originalUpdateMedia(media);
      };

      // Apply the filter for the current layout/selection.
      function sync() {
        var color = currentSelectedColor(productInfo);
        var data = getColorData(productInfo);
        var flkty = getActiveFlickity(productInfo);

        if (color && hasColorData(data)) {
          if (flkty) {
            // Mobile: the server already renders the selected variant's featured
            // image first (and loaded), so just hide the rest and re-flow.
            applyVisibility(productInfo, color);
            reflowFlickity(productInfo, flkty);
            return;
          }
          if (!isMobileViewport()) {
            applyVisibility(productInfo, color);
            return;
          }
        }
        showAll(productInfo);
      }

      // Initial state — defer to window load so Flickity has initialised first.
      if (document.readyState === 'complete') sync();
      else window.addEventListener('load', sync);

      // Keep in sync when the layout flips between slider and stack (resize/rotate).
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(sync, 200);
      });
    }

    customElements.whenDefined('product-info').then(function () {
      document.querySelectorAll('product-info').forEach(setupProductInfo);
    });
  })();


  // Move the Size Chart link up next to the SIZE label.
  //
  // The link is injected at runtime by the "BF Size Charts by Relentless Apps"
  // app, which drops it inside form.shopify-product-form — i.e. below Add to
  // Cart and the payment buttons, far from the size grid it explains. It can't
  // be repositioned with CSS because it lives in a different parent, and the
  // app's placement isn't configurable to the legend.
  //
  // So the node is MOVED (not cloned) into the SIZE fieldset's <legend>, which
  // keeps the app's own click handler attached — verified against the un-moved
  // baseline: the size drawer opens identically either way.
  //
  // The app injects asynchronously, so if the node isn't there yet we watch for
  // it and give up after 10s rather than observing forever.
  (function () {
    function moveSizeGuide() {
      var chart = document.querySelector('.best-fit-size-chart');
      var grid = document.querySelector('.selector-wrapper--grid');
      if (!chart || !grid) return false;
      var legend = grid.querySelector('.radio__legend');
      if (!legend) return false;
      if (legend.contains(chart)) return true;
      legend.appendChild(chart);
      return true;
    }

    if (!moveSizeGuide()) {
      var observer = new MutationObserver(function () {
        if (moveSizeGuide()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 10000);
    }
  })();


  // Move the Judge.me rating onto the price line.
  //
  // The rating badge and the price are separate theme blocks, so no amount of
  // CSS ordering can put them on one row - `order` reorders siblings in a
  // column, it cannot merge two of them. The badge node is therefore MOVED into
  // the price block (Hoka, Nike and On all pair price and rating this way), and
  // the emptied block is flagged so CSS can collapse it.
  //
  // Judge.me injects asynchronously, hence the observer.
  (function () {
    function moveBadge() {
      var badge = document.querySelector('.jdgm-widget.jdgm-preview-badge');
      var price = document.querySelector('.product__block.product__price-and-badge');
      if (!badge || !price) return false;
      if (price.contains(badge)) return true;
      var host = badge.closest('.product__block');
      price.appendChild(badge);
      if (host && host !== price) host.classList.add('product__block--emptied');
      price.classList.add('product__price-and-badge--with-rating');
      return true;
    }

    if (!moveBadge()) {
      var observer = new MutationObserver(function () {
        if (moveBadge()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 10000);
    }
  })();

  // Banner image: make zoom-on-scroll start at 1x at the top of the page.
  // Theme scale = 1 + 0.2 * scrolled / range, where "scrolled" is already large
  // at page load for a hero banner. Remove the part not caused by scrolling.
  (function () {
    function measure() {
      document.querySelectorAll('banner-image-component').forEach(function (el) {
        var p = el.querySelector('parallax-element[data-parallax-animation*="zoom-on-scroll"]');
        var s = parseFloat(el.style.getPropertyValue('--scale'));
        if (!p || !s) return;
        var vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        var range = vh + (p.containerHeight || el.offsetHeight);
        if (p.animations && p.animations.indexOf('card-scrolling') > -1 && p.nextSection) {
          range += p.cardScrollingMarginTop || 0;
        }
        var offset = Math.max(0, s - 1 - (0.2 * window.scrollY) / range);
        el.style.setProperty('--scale-offset', offset.toFixed(4));
      });
    }
    function later() {
      requestAnimationFrame(function () { requestAnimationFrame(measure); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', later);
    } else {
      later();
    }
    window.addEventListener('load', later);
    document.addEventListener('theme:resize', function () { setTimeout(measure, 100); });
    document.addEventListener('shopify:section:load', later);
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();